export default {
  SLIDER: 'slider',
};
